export const USER_PROFILE_VALIDATION_PATTERN = /^([^\d_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]^.,'"-][^\d_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]^]*[^\d_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]^'"])$/;
//# sourceMappingURL=ConstantUtils.js.map